<div class="roadmap">
  <div class="container">
    <h2 class="roadmep_headning">Roadmap</h2>
    <div class="roadmap_outer">
      <div class="roadmap_line">
        <div class="year_line">
          <span>2021</span>
          <div class="quarter top">
            <span class="round"><p>Phase 1</p></span>
            <div class="quarter_text">
              <ul>
                <li class="complete_icon">Smart Contract Audits By Certik</li>
                <li class="complete_icon">CMC CoinGecko Listings</li>
                <li class="complete_icon">1000 Holders</li>
                <li class="complete_icon">Website Launch</li>
                <li class="complete_icon">$DOE Token Launch</li>
                <li class="complete_icon">Dogs Of Elon NFT Launch</li>
                <li class="complete_icon">NFT Airdrop Partnership With CMC</li>
                <li class="complete_icon">User Rewards From Token Staking</li>
              </ul>              
            </div>
          </div>
          <div class="quarter bottom">
            <span class="round"><p>Phase 2</p></span>
            <div class="quarter_text">
              <ul>
                <li class="complete_icon">Charity Donations</li>
                <li class="complete_icon">Marketing</li>
                <li class="complete_icon">CEX Listings</li>
                <li class="complete_icon">Referral Payouts</li>
                <li class="complete_icon">Contract Ownership Renounced</li>
              </ul>              
            </div>
          </div>                         
        </div>
        <div class="year_line">
          <span>2022</span>
          <div class="quarter top">
            <span class="round"><p>Phase 3</p></span>
            <div class="quarter_text">
              <ul>
                <li class="complete_icon">Tesla/$50,000 In ETH Giveaway</li>
                <li class="complete_icon">CMC Airdrop Giveaway</li>
                <li class="complete_icon">P2E Alpha</li>
                <li class="complete_icon">NFT Explorer</li>              
                <li class="progress_icon">DOE DAO</li>
              </ul>              
            </div>
          </div>
          <div class="quarter bottom">
            <span class="round"><p>Phase 4</p></span>
            <div class="quarter_text">
              <ul>
                <li class="not_started">NFT Marketplace</li>
                <li class="not_started">DOE DEX</li>
                <li class="not_started">Onboard Influencers And Advisors</li>
                <li class="not_started">P2E Beta</li>
                <li class="not_started">CEX Listings</li>
              </ul> 
            </div>
          </div> 
          <div class="quarter top">
            <span class="round"><p>Phase 5</p></span>
            <div class="quarter_text">
              <ul>
                <li class="not_started">To Be Announced. Updated Soon.</li>
              </ul>              
            </div>
          </div>                                          
        </div>
      </div>
    </div>
  </div>
</div>